import { Helmet } from 'react-helmet';

interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  imageUrl?: string;
  noindex?: boolean;
  category?: string;
  tags?: string[];
}

export const SEO: React.FC<SEOProps> = ({ 
  title, 
  description, 
  canonicalUrl,
  imageUrl,
  noindex,
  category,
  tags
}) => {
  const siteName = 'POE2 Skills AI';
  const fullTitle = `${title} - ${siteName}`;
  const domain = 'https://poe2skills-ai.com';
  const fullUrl = canonicalUrl ? `${domain}${canonicalUrl}` : domain;
  const defaultImage = `${domain}/images/poe2-logo.jpg`;

  return (
    <Helmet>
      {/* Basic */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={imageUrl || defaultImage} />
      <meta property="og:type" content="website" />
      {category && <meta name="article:section" content={category} />}
      {tags && <meta name="keywords" content={tags.join(', ')} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl || defaultImage} />
    </Helmet>
  );
}; 